import React, { useState } from 'react';
import { DatabaseIcon, CheckCircleIcon } from '@heroicons/react/outline';

const PurchaseSuccessfulPopupBody = ({ setPurchaseSuccessfulPopupOpen }) => {
  return (
    <div className='w-full justify-center '>
      <p>Purchase was successful!</p>
      <br />
      <div className='flex justify-center'>
        <button className='text-black bg-sky-400 hover:bg-sky-500 rounded-full px-3 py-2 font-semibold flex shadow'>
          <CheckCircleIcon
            className='w-6 h-6'
            onClick={() => setPurchaseSuccessfulPopupOpen(false)}
          />
          Ok
        </button>
      </div>
    </div>
  );
};

export default PurchaseSuccessfulPopupBody;
